(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const assignRandomHighlightOrders = () => {
    const grid = document.querySelector('#ResultsList .plp-grid');
    if (!grid) return;

    const highlightItems = Array.from(grid.querySelectorAll('.product-grid__item--highlight'));
    if (!highlightItems.length) return;

    const productItems = grid.querySelectorAll(
      '.product-grid__item:not(.product-grid__item--highlight):not(.product-grid__item--highlight-full)'
    );

    const availableOrders = [];
    const minOrder = 5;
    const maxOrder = productItems.length + highlightItems.length;

    console.log(maxOrder);

    for (let order = minOrder; order <= maxOrder; order += 1) {
      availableOrders.push(order);
    }

    for (let i = availableOrders.length - 1; i > 0; i -= 1) {
      const randomIndex = Math.floor(Math.random() * (i + 1));
      [availableOrders[i], availableOrders[randomIndex]] = [availableOrders[randomIndex], availableOrders[i]];
    }

    highlightItems.forEach((item, index) => {
      item.style.setProperty('--product-grid-item-order', availableOrders[index]);
    });
  };

  const url = new URL(window.location.href);
  document.addEventListener(
    'DOMContentLoaded',
    () => {
      assignRandomHighlightOrders();

      if (url.hash) {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      }
    },
    { once: true }
  );

  } catch(e) { console.error(e); }
})();
})();
